import PropTypes from 'prop-types';
import React from 'react';
import { useTranslations } from 'next-intl';

import StyledSkipLink from './skipLink.style';

const SkipLink = props => {
  const t = useTranslations();
  return (
    <StyledSkipLink {...props} className="skipLink" href="#content">
      {t('skipLink')}
    </StyledSkipLink>
  );
};

SkipLink.propTypes = {
  value: PropTypes.string
};

export default SkipLink;
